// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_40-1";
export var movingGradient = "_40-4";
export var movingGradientBlock = "_40-2";
export var skeleton = "_40-0";
export var skeletonText = "_40-3";